import { cn } from '@/lib/utils';
import { formatoCantidad } from '@/lib/utils/formato-precio';
import { RESULTADOS, cuantasDe } from '../../lib/corridas';
import type { Conteos } from '../../types/corridas.types';

/** La barra apilada de lo que pasó con lo propuesto (maqueta: `.sbar`). Sin propuestas, nada. */
export function BarraDeResultados({
  conteos,
  className,
}: {
  conteos: Conteos;
  className?: string;
}) {
  if (conteos.propuestas === 0) return null;
  const partes = RESULTADOS.map((r) => ({ ...r, n: cuantasDe(conteos, r.clave) })).filter(
    (r) => r.n > 0
  );
  return (
    <div
      role="img"
      aria-label={partes.map((r) => `${r.plural}: ${formatoCantidad(r.n)}`).join(', ')}
      className={cn('flex h-2 w-full overflow-hidden rounded-full bg-muted', className)}
    >
      {partes.map((r) => (
        <span
          key={r.clave}
          className={r.fondo}
          style={{ width: `${(r.n / conteos.propuestas) * 100}%` }}
          title={`${r.plural}: ${formatoCantidad(r.n)}`}
        />
      ))}
    </div>
  );
}

/** La leyenda: sólo los que tienen alguna. */
export function LeyendaDeResultados({ conteos }: { conteos: Conteos }) {
  return (
    <ul className="flex min-w-0 flex-wrap gap-x-3 gap-y-1 text-xs text-muted-foreground">
      {RESULTADOS.map((r) => {
        const n = cuantasDe(conteos, r.clave);
        return n > 0 ? (
          <li key={r.clave} className="inline-flex items-center gap-1.5">
            <span aria-hidden="true" className={cn('h-2 w-2 shrink-0 rounded-full', r.fondo)} />
            {r.plural}{' '}
            <b className="font-semibold tabular-nums text-foreground">{formatoCantidad(n)}</b>
          </li>
        ) : null;
      })}
    </ul>
  );
}
